import React from 'react';
import wrapPage from './wrap-page-element';

// Base styles
import 'normalize.css/normalize.css';
import './src/index.css';

// Global fonts
import '@openfonts/noto-sans-jp_latin';
import '@openfonts/noto-sans-jp_japanese';

// Providers
import Providers from './src/providers';

export const wrapRootElement = ({ element }) => {
  return <Providers>{element}</Providers>;
};

export const wrapPageElement = wrapPage;
export const shouldUpdateScroll = () => {
  // Scroll to top of page on page change
  const element = document.getElementById('content');
  if (element) {
    element.scrollTop = 0;
  }
  return false;
};
